import Page from "../../components/Page";
import useUsersList from "./hooks/useUsersList";

const UsersList = () => {
  const page = useUsersList();
  return <Page {...page} />;
};

export default UsersList;
